module.exports = __webpack_public_path__ + "img/21.5-gallery.0568bb98.jpg";